import React, { useEffect, useState } from 'react';

// ENUMS
import { StickyType } from '../../enums/sticky';

// INTERFACES
import { ISticky } from '../../interfaces/Sticky.interface';

// STYLES
import { 
  StickyBody, 
  StickyContainer, 
  StickyItemContainer, 
  StickyStyled, 
  Title 
} from './styles';

const Sticky: React.FC<ISticky> = ({ 
  items = [], 
  title, 
  type = StickyType.DEFAULT, 
  variant 
}: ISticky) => {
  const [isScrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (type !== StickyType.DEFAULT) {
      return;
    }

    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      setScrolled(currentScroll >= 200);
    });
  });

  return (
    <StickyStyled isScrolled={isScrolled} type={type}>
      <StickyContainer>
        <Title type={type} variant={variant}>
          {title}
        </Title>
        <StickyBody type={type}>
          {items.map((item: any, idx: number) => (
            <StickyItemContainer type={type} key={idx}>
              {item}
            </StickyItemContainer>
          ))}
        </StickyBody>
      </StickyContainer>
    </StickyStyled>
  );
};

export default Sticky;
